/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Players_Drop_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Drop {name}?" |
*
* @param {Players_Drop_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_drop_confirm_title = /** @type {((inputs: Players_Drop_Confirm_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_Drop_Confirm_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Déclarer l'abandon de ${i?.name} ?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`¿Retirar a ${i?.name}?`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Retirar ${i?.name}?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Ritirare ${i?.name}?`)
	return /** @type {LocalizedString} */ (`Drop ${i?.name}?`)
});